import {
    dashboardPageUrlRegExp,
    myAccountAddressBookPageUrlRegExp,
    myAccountAddTaxIDPageUrlRegExp,
    myAccountMyListPageUrlRegExp,
    myAccountOrderHistoryPageUrlRegExp,
    myAccountPaymentMethodPageUrlRegExp,
    myAccountVatIdPageUrlRegExp,
    myProfilePageUrlRegExp,
    myRegisteredProductsPageUrlRegExp,
    myPartnerPortalPageUrlRegExp,
} from './url-reg-exp';

export const pagePatternDictionary = [
    { pattern: dashboardPageUrlRegExp, pageName: 'Dashboard' },
    { pattern: myProfilePageUrlRegExp, pageName: 'Profile' },
    { pattern: myAccountMyListPageUrlRegExp, pageName: 'My-Favorites' },
    { pattern: myAccountAddressBookPageUrlRegExp, pageName: 'Address-Book' },
    { pattern: myAccountPaymentMethodPageUrlRegExp, pageName: 'Payment-methods' },
    { pattern: myAccountAddTaxIDPageUrlRegExp, pageName: 'Tax-id' },
    { pattern: myAccountVatIdPageUrlRegExp, pageName: 'Vat-id' },
    { pattern: myAccountOrderHistoryPageUrlRegExp, pageName: 'Order-history' },
    { pattern: myRegisteredProductsPageUrlRegExp, pageName: 'My-registered-products' },
    { pattern: myPartnerPortalPageUrlRegExp, pageName: 'My-partner-portal' },
];
